@if (!loading) {
  <app-patient-header [patient]="patient" />
  <div class="row">
    <div class="col-6">
      @for (table of tables; track table) {
        <div>
          <div class="card mt-3">
            <div class="card-body">
              <h4>{{ table.title }}</h4>
              @if (table.documents.length > 0) {
                <table class="table table-sm table-bordered table-hover">
                  <thead>
                    <tr>
                      <th class="min-width">ID</th>
                      <th>DOCUMENT NAME</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (document of table.documents; track document) {
                      <tr
                        [ngClass]="document.id === selectedDocument?.id ? 'selected' : 'clickable'"
                        (click)="displayDocument(document.id)" >
                        <td class="min-width">{{ document.id }}</td>
                        <td class="phi">
                          {{ document | patientAttachmentListingDisplayName }}
                          <app-patient-attachment-duplicate [patientAttachment]="document" />
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              } @else {
                No documents.
              }
            </div>
          </div>
        </div>
      }
    </div>
    <div class="col-6">
      @if (selectedDocument) {
        <div class="card mt-3">
          <div class="card-title p-2">
            VIEWING:
            @if (selectedDocument.type === 'StandardConsultNote') {
              <a
                target="_blank"
                routerLink="/capture-admin/consult-notes/{{selectedDocument.id}}">
                {{ selectedDocument | patientAttachmentListingDisplayName }}
              </a>
            } @else {
              {{ selectedDocument | patientAttachmentListingDisplayName }}
            }
            @if (currentDocument) {
              <app-patient-attachment-duplicate-link [patientAttachment]="currentDocument" />
            }
          </div>
          @if (!loadingDocument) {
            <div class="card-body">
              <div class="card mt-3 p-2">
                <div>
                  @switch (selectedDocument.type) {
                    @case ('StandardConsultNote') {
                      <div>
                        <ng-container *ngTemplateOutlet="standardConsultNoteTemplate" />
                      </div>
                    }
                    @case ('EhrConsultNoteReference') {
                      <div>
                        <ng-container *ngTemplateOutlet="ehrConsultNoteReferenceTemplate" />
                      </div>
                    }
                    @case ('OutreachAttemptEvidence') {
                      <div>
                        <ng-container *ngTemplateOutlet="outreachAttemptEvidenceTemplate" />
                      </div>
                    }
                  }
                </div>
              </div>
              <ng-template #ehrConsultNoteReferenceTemplate>
                <div class="card-title p-2">
                  Consult Note Reference
                </div>
                <div class="card-body">
                  <div><strong>Consult Note Name</strong></div>
                  <div>{{ currentDocument.ehrConsultNoteReference.name }}</div>
                  <div class="mt-3"><strong>Client Note</strong></div>
                  <div>{{ currentDocument.ehrConsultNoteReference.notes }}</div>
                  <div class="mt-3"><strong>Created</strong></div>
                  <div>{{ currentDocument.ehrConsultNoteReference.createdAt | date: 'MM/dd/yyyy  hh:mm a' }} - {{ currentDocument.ehrConsultNoteReference.user.email }}</div>
                </div>
              </ng-template>
              <ng-template #outreachAttemptEvidenceTemplate>
                <div class="card-body">
                  <h4>Outreach Attempt Evidence</h4>
                  @if (currentDocument.provider?.fullName) {
                    <div class="mb-3">
                      Office(s) for {{ currentDocument.provider?.fullName.toUpperCase() }} with relevant outreach attempts.
                    </div>
                  } @else {
                    <div class="fst-italic mb-3">No provider is associated with this outreach attempt evidence record.</div>
                  }
                  @if (outreachAttemptEvidenceOffices.length > 0) {
                    <table class="table">
                      <thead>
                        <tr>
                          <th>OFFICE DETAILS</th>
                          <th>FAX STATUS</th>
                          <th>PROVIDER FAX STATUS</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (office of outreachAttemptEvidenceOffices; track office) {
                          <tr>
                            <td class="small">
                            <app-office [office]="office" /> </td>
                            <td>{{ keyedOfficeStatusOptions[office.status].display }}</td>
                            <td>{{ providerOfficeFaxStatuses[office.id] }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  } @else {
                    <div class="fst-italic mt-2">No offices are associated with this outreach attempt evidence record.</div>
                  }
                  <div class="mt-3"><strong>Effective Date</strong></div>
                  <div>{{ currentDocument.outreachAttemptEvidence.lastOutreachDate }}</div>
                  <div class="mt-3"><strong>Justification</strong></div>
                  <div>{{ currentDocument.outreachAttemptEvidence.notes }}</div>
                </div>
              </ng-template>
              <ng-template #standardConsultNoteTemplate>
                @if (currentDocument.url) {
                  @if (!usePdfKitViewer) {
                    <app-pdf-file-viewer
                      height="86rem"
                      [pdfFile]="currentDocument"
                      [pdfFileType]="pdfFileType" />
                  }
                  @if (usePdfKitViewer) {
                    <app-pdfkit-file-viewer
                      height="86rem"
                      [pdfFile]="currentDocument"
                      [pdfFileType]="pdfFileType"
                      (urlChange)="onUrlChange($event)" />
                  }
                } @else {
                  No PDF file is associated with the attachment.
                }
              </ng-template>
            </div>
          } @else {
            <mat-spinner class="mt-2 mb-2 centered" [diameter]="30"/>
          }
        </div>
      }
    </div>
  </div>
} @else {
  <mat-spinner />
}

